module.exports = __webpack_public_path__ + "c575d1eedb2bdcc59adfb77b732e492f.jpg";